import React, { ReactNode } from 'react';
import CustomHead from './CustomHead';
import DownloadSection from './DownloadSection';
import Footer from './Footer';
import NavBar from './NavBar';

type Props = {
  children: ReactNode;
  head?: ReactNode;
  showStandardDownloadSection?: boolean;
  showNavBar?: boolean;
};

const DefaultHead = <CustomHead />;

export default function StandardLayout({
  head = DefaultHead,
  showStandardDownloadSection = true,
  showNavBar = true,
  children,
}: Props) {
  return (
    <div>
      {head}
      {showNavBar && <NavBar />}
      <main>
        {children}
        {showStandardDownloadSection && <DownloadSection />}
      </main>
      <Footer />
    </div>
  );
}
